import React from 'react';
import Button from '../Button';
import Card from '../Card';

const PageNotFound = () => {
  return (
    <div className="p-6 pt-12 w-136 m-auto">
      <Card className="flex flex-col text-center gap-4" padding="py-24">
        <h1 className="text-4xl font-bold">404</h1>
        <span>Page Not Found</span>
        <div>
          <Button type="button" onClick={() => window.history.back()}>
            Go Back
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default PageNotFound;
